// NOTE: This "PROD" file is actually the one built into TEST/UAT packages
import { environment_core, urlConfigs } from "./environment.core";

export const environment = {
    ...environment_core,
    production: true,
    envName: 'prod',
    appName: "myadminis",

    /* Adding a config appName to this array allows this config to be loaded via URL in a TEST environment 
        For example via, https://my-test10.adminis.co.nz/welcome .
        Had to put this here because this PROD environment file is actually the one used for all deployments to TEST/UAT.
        There is a hard wired code check for TEST/UAT/PREPROD instead.
    */
    allowedUrlConfigs: urlConfigs
};
